/** US states + DC postal abbreviations for address entry. */
export const US_STATE_ABBREVIATIONS = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
  'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
  'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
  'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
  'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
] as const;

export type UsStateAbbrev = (typeof US_STATE_ABBREVIATIONS)[number];

const STATE_NAME_TO_ABBREV: Record<string, UsStateAbbrev> = {
  OHIO: 'OH',
  NEVADA: 'NV',
};

const ABBREV_SET = new Set<string>(US_STATE_ABBREVIATIONS);

/** Trim, uppercase, and map known full names (OHIO, NEVADA) to abbreviations. */
export function normalizeUsState(value: string | null | undefined): string {
  if (!value) return '';
  const cleaned = value.trim().toUpperCase();
  if (!cleaned) return '';
  return STATE_NAME_TO_ABBREV[cleaned] ?? cleaned;
}

export function isValidUsStateAbbrev(value: string | null | undefined): boolean {
  if (!value) return true;
  return ABBREV_SET.has(normalizeUsState(value));
}
